<template>
  <v-container
    id="servicos"
    fluid
     class="grey lighten-3 py-0 px-0"
  >
    <v-row
      class="pt-12"
    >
      <v-col
        cols="12"
        class="text-center"
      >
        <h2 class="display-1 font-weight-bold pt-0">
          <span class="barlow primary--text">SERVIÇOS</span>
        </h2>
      </v-col>
    </v-row>
    <v-row
      class="pb-12"
    >
      <v-col
        cols="12" md="4"
        v-for="(s,i) in servicos"
        :key="i"
      >
        <v-card
          :hover="url(s.url)"
          :href="s.url"
          target="_blank"
          class="fill-height py-4"
        >
          <v-icon large left class="primary--text px-4">{{s.icone}}</v-icon>
          <v-card-title class="headline pt-1">
            <span class="barlow font-weight-medium">{{s.titulo}}</span>
          </v-card-title>
          <v-card-text>
            {{s.descricao}}
          </v-card-text>
          <v-card-actions class="pt-0 px-3">
            <v-btn
              v-if="s.url"
              class="primary"
            >Saiba Mais <v-icon class="">mdi-chevron-right</v-icon></v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      class="pb-12"
    >
      <v-col
        cols="12"
        class="text-center"
      >
        <v-btn
          x-large
          class="primary font-weight-bold"
          @click="$vuetify.goTo('#contato')"
        >Agendar Atendimento</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      servicos: [
        {
          icone: 'mdi-summit',
          titulo: 'Coaching Generativo',
          descricao: 'Esta metodologia tem como objetivo criar uma nova realidade a partir da criatividade e, dessa forma, conquistar resultados até então inalcançáveis pelo indivíduo. Justamente por isso, o coaching generativo ajuda na concretização de sonhos e metas e na construção de um futuro melhor e mais rico. O processo pode beneficiar qualquer pessoa, desde quem busca refletir sobre algum aspecto da vida pessoal até um líder que deseja elevar a performance da empresa.',
          url: null
        },
        {
          icone: 'mdi-google-circles-communities',
          titulo: 'Constelação Sistêmica Familiar (em grupo ou individual)',
          descricao: 'A Constelação Familiar é uma prática terapêutica usada para tratar questões físicas e mentais a partir da revelação das dinâmicas ocultas de uma família. Por meio da constelação familiar é possível identificar acontecimentos que, mesmo desconhecidos, podem trazer problemas para a vida de uma pessoa. Essa prática pode ser entendida como uma terapia breve, ou seja, que não requer repetidas sessões para elucidar uma questão. Isso acontece porque a constelação familiar atua de forma energética e visa solucionar um conflito por vez. Suas dinâmicas consistem em montar o sistema familiar e entrar em contato com o campo morfogenético do sistema familiar do cliente. Esse contato possibilita identificar os motivos que possam ter ocasionado um desequilíbrio nesse sistema.',
          url: 'https://institutoaltoimpacto.com.br/servicos/constelacao-sistemica'
        },
        {
          icone: 'mdi-account-circle-outline',
          titulo: 'Psicanálise',
          descricao: 'A psicanálise é um método de investigação da mente humana e dos seus processos, que eleva a mente para além das suas relações biológicas e fisiológicas. Para tanto, ela toma como objeto os processos mentais (emoções, sentimentos, impulsos e pensamentos) que determinam os indivíduos. Dentre os inúmeros benefícios, estão: Desenvolve o autoconhecimento, Fornece a oportunidade de se reinventar, Ensina a lidar com as emoções, e Promove uma boa saúde mental.',
          url: null
        },
        {
          icone: 'mdi-file-document-edit-outline',
          titulo: 'Escrita Terapêutica (em grupo)',
          descricao: 'Quando escrevemos, podemos expressar as nossas emoções mais profundas, organizar os nossos pensamentos mais caóticos e conectar com o nosso manancial de criatividade e sabedoria interior. Escrever é terapêutico na medida em que permite a nossa expressão espontânea e autêntica. Quando escrevemos, nos vemos diante de nós mesmos. A escrita convida a este auto-encontro. Escrever é um caminho para materializar a nossa subjetividade. Permitir-se escrever terapeuticamente é trazer à tona o nosso mundo interior. A prática diária da escrita terapêutica estimula a criatividade, no sentido de resolução dos problemas. Ao extravasar os sentimentos através das palavras, torna-se cada vez mais natural termos insights diversos sobre as circunstâncias que se apresentam no dia a dia.',
          url: null
        },
        {
          icone: 'mdi-thought-bubble-outline',
          titulo: 'Hipnose Clínica',
          descricao: 'A hipnose clínica é uma excelente ferramenta de trabalho para o psicólogo. Por meio dela, é possível tratar a fundo os problemas trazidos pelos pacientes (cuja raiz está no inconsciente) em um tempo menor se comparado às psicoterapias tradicionais. Quando feita em consultório, a técnica de hipnose traz inúmeros benefícios à saúde, inclusive para a cura de determinadas doenças físicas ou emocionais. A hipnose faz o paciente encontrar em si mesmo a força a e confiança para enfrentar seus problemas e recuperar o equilíbrio e o bem-estar do seu corpo. Os problemas mais comuns tratados com hipnose terapêutica são fobias em geral, depressão, síndrome do pânico, TOC, ansiedade, insônia, vícios, estresse, transtornos alimentares, bruxismo (ranger dos dentes à noite), doenças psicossomáticas, enxaqueca, além de vários tipos de dores e problemas sexuais como impotência, diminuição da libido e ejaculação precoce.',
          url: null
        },
        {
          icone: 'mdi-brain',
          titulo: 'Programação Neurolinguística',
          descricao: 'O primeiro benefício evidente da PNL é que ela favorece o autoconhecimento. Conhecer a si próprio é a base para qualquer mudança, seja ela grande ou pequena, pois não podemos gerir aquilo que não conhecemos a fundo. Através do autoconhecimento, uma pessoa identifica seus pontos fortes, que devem ser potencializados, e também os pontos fracos, que podem ser trabalhados ou minimizados. Além de saber mais sobre as particularidades e o que motiva comportamentos específicos, a PNL traz a compreensão sobre processos mentais e a formação de hábitos, comuns a qualquer ser humano. Portanto, ela ajuda no desenvolvimento de habilidades como a empatia, identificação de padrões e estilo de vida das pessoas que nos rodeiam, dando base a relacionamentos saudáveis. O processo de PNL também auxilia no aprimoramento de profissionais atuantes nos mais diversos segmentos de mercado.',
          url: null
        },
      ]
    }
  },
  computed: {
    
  },
  methods: {
    getImg(i) {
      return require('@/assets/img/'+i)
    },
    url (val) {
      return val != null ? true : false
    },
  }
}
</script>